import React, { FC, useMemo } from "react";

import { useTranslation } from "react-i18next";
import customFilterStyles from "../customFilterComponent/customFiltersStyles";
import { DevicesStyles } from "../userDevices/DevicesStyles";
import { CustomFilterButton } from "../customFilterComponent/customFilterButton";
import { useLicenseColumns } from "./LicenceColumns";
import { useDispatch, useSelector } from "react-redux";
import useLicensesFilters from "./ExtraFilters";
import {
  LicensesFilters,
  selectUsersWithNoLicenses,
  setFilterModel,
  setPreselectedFilterField,
  setShowFilterForm,
} from "../../redux/slices/licenses/licenseList";
import { applyLocalFilter } from "../helpers/helpersSearchs";
import { ThunkDispatch } from "@reduxjs/toolkit";

import { statusLicensesOptions } from "./StatusOptions";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    /// custom filter component
    setFilterModel: (filterModel: any) => {
      dispatch(setFilterModel(filterModel));
    },

    setShowFilterForm: (show: boolean) => {
      dispatch(setShowFilterForm(show));
    },

    setPreselectedFilterField: (field: string | null) => {
      dispatch(setPreselectedFilterField(field));
    },
  };
};

const Filters: FC = () => {
  const [t] = useTranslation("global");
  const dispatch = useDispatch();
  const { setFilterModel, setShowFilterForm, setPreselectedFilterField } =
    SetActions();

  const { filter } = useLicensesFilters();
  const filters = filter();

  const { licenseColumns, licensesRows } = useLicenseColumns(t, dispatch);
  const { filterModel, showFilterForm, preselectedFilterField } =
    useSelector(LicensesFilters);
  const usersWithNoLicenses = useSelector(selectUsersWithNoLicenses) as any[];

  const isUsersNoLicensesMode = filterModel?.items?.some(
    (item) =>
      item.field === "licensesStatus" && item.value === "usersNoLicenses",
  );

  const filterTheFilterModel = useMemo(
    () => ({
      ...filterModel,
      items:
        filterModel?.items?.filter(
          (item) =>
            item.field !== "licensesStatus" ||
            item.value === "expiringSoon" ||
            item.value === "runningLow",
        ) ?? [],
    }),
    [filterModel],
  );

  const filterStatusOptions = statusLicensesOptions(t).filter((option) => {
    return (
      option.value !== "active" &&
      option.value !== "unassigned" &&
      option.value !== "expired" &&
      option.value !== "upcoming"
    );
  });

  const textFilterItems =
    filterModel?.items?.filter(
      (item) => item.service === "text" || item.service === "operator",
    ) ?? [];

  const hasNoData = isUsersNoLicensesMode
    ? usersWithNoLicenses.filter((user) =>
        textFilterItems.every((item) =>
          applyLocalFilter(item, {
            username: user.username,
            siteName: user.associatedGeoPoint?.[0]?.name ?? null,
          }),
        ),
      ).length === 0
    : licensesRows.length === 0;

  const safeSetFilterModel = (newFilterModel: any) => {
    const quickBarItems =
      filterModel?.items?.filter(
        (item) =>
          item.field === "licensesStatus" &&
          item.value !== "expiringSoon" &&
          item.value !== "runningLow",
      ) ?? [];

    const formLicenseStatusItems =
      newFilterModel?.items?.filter(
        (item: any) => item.field === "licensesStatus",
      ) ?? [];

    setFilterModel({
      ...newFilterModel,
      items: [
        ...quickBarItems,
        ...formLicenseStatusItems,
        ...(newFilterModel?.items?.filter(
          (item: any) => item.field !== "licensesStatus",
        ) ?? []),
      ],
    });
  };

  return (
    <div
      style={{
        ...customFilterStyles.filterContainer,
        marginLeft: "60px",
        marginRight: "13px",
      }}
    >
      <div style={DevicesStyles.containerFilterButon}>
        <CustomFilterButton
          t={t}
          isDisabled={false}
          loadingsValues={false}
          filterModel={filterTheFilterModel}
          setShowFilterForm={setShowFilterForm}
          showFilterForm={showFilterForm}
          setPreselectedFilterField={setPreselectedFilterField}
          preselectedField={preselectedFilterField}
          columnsTable={filters.concat(licenseColumns) as any}
          setFilterModel={safeSetFilterModel}
          handleApplyFilters={() => {}}
          hasNoData={hasNoData}
          sectionName={"licenses"}
          statusOptions={filterStatusOptions}
        />
      </div>
    </div>
  );
};

export default Filters;
